import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@tyro/i18n';
import {
  ArrowLeftIcon,
  BookOpenIcon,
  CloseIcon,
  CollapseIcon,
  FullScreenIcon,
} from '@tyro/icons';
import {
  useReaderActions,
  useReaderState,
} from '../../store/documentation-reader-provider';

export function ReaderHeader() {
  const { t } = useTranslation(['documentation']);
  const { goBack, close, toggleFullScreen } = useReaderActions();
  const { canGoBack, isFullScreen } = useReaderState();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        p: 1,
        pl: 2,
        borderBottom: 'solid 1px',
        borderBottomColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ flex: 1, minWidth: 0 }}
      >
        {canGoBack && (
          <Tooltip title={t('documentation:reader.back')}>
            <IconButton
              onClick={goBack}
              size="small"
              sx={{ width: 32, height: 32 }}
            >
              <ArrowLeftIcon sx={{ width: 18, height: 18 }} />
            </IconButton>
          </Tooltip>
        )}
        <BookOpenIcon sx={{ width: 20, height: 20, color: 'primary.main' }} />
        <Typography component="h2" variant="h6" noWrap sx={{ minWidth: 0 }}>
          {t('documentation:reader.title')}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={0.5}>
        <Tooltip
          title={t(
            isFullScreen
              ? 'documentation:reader.exitFullScreen'
              : 'documentation:reader.enterFullScreen',
          )}
        >
          <IconButton
            onClick={toggleFullScreen}
            size="small"
            sx={{ width: 32, height: 32 }}
          >
            {isFullScreen ? (
              <CollapseIcon sx={{ width: 18, height: 18 }} />
            ) : (
              <FullScreenIcon sx={{ width: 18, height: 18 }} />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title={t('documentation:reader.close')}>
          <IconButton
            onClick={close}
            size="small"
            sx={{ width: 32, height: 32 }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    </Stack>
  );
}
